module.exports = "https://cdn.thelire.com/ins/resource/icon_line_cancel.fce3036feb7b8132d09840e83dfea64d.png";